import React, { Dispatch, SetStateAction } from 'react'

import {
    BoldText,
    StyledFinanceModalContent,
    FinanceModalParagraph,
    FinanceModalSubtitle,
    FinanceModalTitle,
    StyledInfoModal,
} from '../search-listing-details/search-listing-details.styles'

import { ModalVariant } from '@at/design-system-patterns'
import { PortalComponent } from '../modals/portal'
import { SearchResultsListingsGridQuery_searchResults_SearchResults_listings_SearchListing_finance_BasicListingFinance_representativeValues_RepresentativeValues } from '../../contexts/search-results-context/query/__generated__/search-results-listings.fed.query'
import { focusOnElement } from '../../utils/focus-on-element'
import { FinanceRepresentativeExample } from '../search-listing-details/finance-representative-example'
import { FinanceLegalText } from '../search-listing-details/finance-representative-example.styles'
import {
    LEASING_FINANCE_FULL_BREAKDOWN_DISCLAIMER_STATIC_COPY,
    LEASING_FINANCE_FULL_BREAKDOWN_TITLE_STATIC_COPY,
    LEASING_FINANCE_HEADER_CONTRACT_TYPE_STATIC_COPY,
    LEASING_FINANCE_HEADER_HOW_MUCH_IT_COST_STATIC_COPY,
    LEASING_FINANCE_HEADER_PLEASE_NOTE_STATIC_COPY,
    LEASING_FINANCE_THE_LEGAL_BIT_BODY_0_STATIC_COPY,
    LEASING_FINANCE_THE_LEGAL_BIT_BODY_1_STATIC_COPY,
    LEASING_FINANCE_THE_LEGAL_BIT_BODY_2_STATIC_COPY,
    LEASING_FINANCE_THE_LEGAL_BIT_BODY_3_STATIC_COPY,
    LEASING_FINANCE_THE_LEGAL_BIT_BODY_4_STATIC_COPY,
    LEASING_FINANCE_THE_LEGAL_BIT_BODY_5_STATIC_COPY,
    LEASING_FINANCE_THE_LEGAL_BIT_BODY_6_STATIC_COPY,
    LEASING_FINANCE_THE_LEGAL_BIT_TITLE_STATIC_COPY,
} from '@at/consumer-ui-text/lib/finance/shared/finance.shared.leasing'

export const LeasingFinanceBreakdownModalContent = ({
    showModal,
    setShowModal,
    representativeValues,
    advertId,
}: {
    showModal: boolean
    setShowModal: Dispatch<SetStateAction<boolean>>
    representativeValues?:
        | ReadonlyArray<SearchResultsListingsGridQuery_searchResults_SearchResults_listings_SearchListing_finance_BasicListingFinance_representativeValues_RepresentativeValues>
        | undefined
    advertId: string
}) => {
    return (
        <>
            {showModal && (
                <PortalComponent show={showModal}>
                    <StyledInfoModal
                        isShowing={true}
                        closeText={'Back'}
                        hideFn={() => {
                            setShowModal(false)
                            focusOnElement(advertId)
                        }}
                        variation={ModalVariant.SLIDE}
                        hasBackLink={false}
                        modalTitle="Leasing finance breakdown"
                        focusId="modal-button"
                        modalHashName="leasing-finance-breakdown-modal"
                        className="info-modal"
                    >
                        <StyledFinanceModalContent>
                            <FinanceModalTitle as="h1">Leasing finance breakdown</FinanceModalTitle>
                            <FinanceModalParagraph as="p">
                                {LEASING_FINANCE_HEADER_HOW_MUCH_IT_COST_STATIC_COPY}
                                <br />
                                <BoldText>{LEASING_FINANCE_HEADER_PLEASE_NOTE_STATIC_COPY} </BoldText>
                                {LEASING_FINANCE_HEADER_CONTRACT_TYPE_STATIC_COPY}
                            </FinanceModalParagraph>
                            <FinanceModalSubtitle as="h2">
                                {LEASING_FINANCE_FULL_BREAKDOWN_TITLE_STATIC_COPY}
                            </FinanceModalSubtitle>
                            {representativeValues?.map((value) => {
                                return (
                                    <FinanceRepresentativeExample
                                        key={value.financeKey}
                                        title={value.financeKey}
                                        value={value.financeValue}
                                    ></FinanceRepresentativeExample>
                                )
                            })}
                            <p>{LEASING_FINANCE_FULL_BREAKDOWN_DISCLAIMER_STATIC_COPY}</p>
                            <p>{LEASING_FINANCE_THE_LEGAL_BIT_BODY_6_STATIC_COPY}</p>
                            <FinanceModalSubtitle as="h2">
                                {LEASING_FINANCE_THE_LEGAL_BIT_TITLE_STATIC_COPY}
                            </FinanceModalSubtitle>
                            <FinanceLegalText as="div">
                                <p>{LEASING_FINANCE_THE_LEGAL_BIT_BODY_0_STATIC_COPY}</p>
                                <p>{LEASING_FINANCE_THE_LEGAL_BIT_BODY_1_STATIC_COPY}</p>
                                <p>{LEASING_FINANCE_THE_LEGAL_BIT_BODY_2_STATIC_COPY}</p>
                                <p>{LEASING_FINANCE_THE_LEGAL_BIT_BODY_3_STATIC_COPY}</p>
                                <p>{LEASING_FINANCE_THE_LEGAL_BIT_BODY_4_STATIC_COPY}</p>
                                <p>{LEASING_FINANCE_THE_LEGAL_BIT_BODY_5_STATIC_COPY}</p>
                            </FinanceLegalText>
                        </StyledFinanceModalContent>
                    </StyledInfoModal>
                </PortalComponent>
            )}
        </>
    )
}
